/** @jsx jsx */

import { useState, useContext, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import getStore from 'services/getStore';

const store = getStore();

const { lPink, mint } = colors;

let lastPageMessageReceived = false;

const LastPageMessage = () => {
  const [showLastPageMessage, setShowLastPageMessage] = useState(
    lastPageMessageReceived
  );

  const Arrow = ({ width = 5, height = 13 }) => (
    <div
      css={css`
        position: absolute;
        left: -5px;
        top: 50%;
        width: ${width}px;
        height: ${height}px;
        transform: translateY(-50%);
      `}
    >
      <svg width={width} height={height}>
        <polygon
          points={`${width},0 0,${height / 2} ${width},${height}`}
          style={{
            fill: mint || lPink,
          }}
        />
      </svg>
    </div>
  );

  return !lastPageMessageReceived ? (
    <div
      className="fader_-5s"
      css={css`
        position: absolute;
        left: calc(100% + 15px);
        top: 50%;
        min-width: 250px;
        padding: 20px;
        transform: translateY(-50%);
        background: ${mint || lPink};
        border-radius: 10px;
        font-size: 12px;
        color: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        pointer-events: none;
        z-index: 2147483638;
      `}
    >
      <div>
        This is the last page of your module. Consider adding an 'Exit' action
        and label, or removing the button altogether.
      </div>

      <div
        css={css`
          display: inline-block;
          margin: 10px 0 0 0;
          padding: 5px 10px;

          background: #fff;
          font-size: 12px;
          color: ${mint || lPink};
          border-radius: 9999px;
          cursor: pointer;

          pointer-events: auto;
        `}
        onClick={e => {
          e.stopPropagation();
          setShowLastPageMessage((lastPageMessageReceived = true));
        }}
      >
        Got it!
      </div>
      <Arrow />
    </div>
  ) : null;
};

export default LastPageMessage;
